import React from "react";
import { withRouter } from "react-router";
import AgregarPromocion from "./AgregarPromocion";
const EditarPromocion = props => {
    return <AgregarPromocion editar={true} />;
};

export default withRouter(EditarPromocion);
